<template>
    <div style="overflow: hidden">
        <el-container>
            <el-header style="padding: 8px 0px 0px 10px; height: 70px !important;">
                <el-form label-position="top" ref="queryform" :model="queryform">
                    <el-row :gutter=8>
                        <el-col :span=19>
                            <el-row :gutter=7>
                                <el-col :span=12>
                                    <el-form-item :label="$t(i18nPage+'导入时间')" prop="authstat">
                                        <zm-date v-model="queryform.date" :date-type="'datetimerange'"></zm-date>
                                    </el-form-item>
                                </el-col>
                                <el-col :span=6 v-if="statshow">
                                    <el-form-item :label="$t(i18nPage+'网点')" prop="statId">
                                        <auth-stat ref="authstat" v-model="queryform.statId" ></auth-stat>
                                    </el-form-item>
                                </el-col>
                                <el-col :span=6>
                                    <el-form-item :label="$t(i18nPage+'状态')" prop="importStatus">
                                        <simple-table table-name="bas_import_state" v-model="queryform.importStatus"></simple-table>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span=5 class="colbutton">
                            <el-button type="primary" @click="$refs['maintable'].query()" :loading="queryLoading" class="zm-button2">{{$t(i18nPage+'查询')}}</el-button>
                            <el-button class="zm-button2" @click="formClick">{{$t(i18nPage+'重置')}}</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-header>
            <el-main>
                <common-table ref="maintable" :col="col" :pagination=true :get-params="getTableParam"
                              :table-height=420 :is-auto=false :start-query=false
                               @button-loading="val => queryLoading = val" @after-load="handleResult">
                </common-table>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    export default {
        name: "ImportLog",
        beforeCreate() {
          this.i18nPage = 'page.ImportLog.';
      },
        props: {
            excelTemplateId:{
                type:Number
            },
            importType:{
                type:String
            }
        },
        data(){
          return {
              i18nPage : 'page.ImportLog.',
              statshow:true,
              col:[{value: 'batchNo', text: this.i18nPage+'批次号',width: 110},
                  // {value: 'importDatetime',text: '导入时间',width: 150,filter:'zmdatetime'},
                  {value: 'createDatetime',text: this.i18nPage+'导入时间',width: 150,filter:'zmdatetime'},
                  {value: 'modifyDatetime',text: this.i18nPage+'结束时间',width: 150, filter:'zmdatetime', formatter:this.isShow},
                  {value: 'differTime',text: this.i18nPage+'导入耗时',width: 150},
                  {value: 'station',text: this.i18nPage+'导入网点',width: 100},
                  {value: 'fileName',text: this.i18nPage+'导入文件',width: 130,toButton:this.downloadUploadFile},
                  {value: 'importStatusName',text: this.i18nPage+'状态',width: 80},
                  {value: 'errorRemark',text: this.i18nPage+'错误描述',width: 100},
                  {value: 'errorCount',text: this.i18nPage+'错误行数',width: 100,align:'right',toButton:this.downloadErrorFile},
                  {value: 'count',text: this.i18nPage+'总行数',width: 100,align:'right'},
                  {value: 'importUserName',text: this.i18nPage+'导入人',width: 120}
              ],
              queryLoading:false,
              queryform:{
                  date:[],
                  statId:null,
                  importStatus:''
              }
          }
        },
        computed:{
        },
        methods: {
            formClick(){
                this.$nextTick(()=>{
                    this.$refs['queryform'].resetFields();
                    this.queryform.date=[this.$date.initDateFirst(-30,true), this.$date.initDateEnd(0,true)];
                });
            },
            getTableParam(){
                if(!this.excelTemplateId && !this.importType){
                    return null;
                }
                var _params = {
                    statId : this.queryform.statId,
                    importStatus: this.queryform.importStatus
                };
                if(this.queryform.date && this.queryform.date.length == 2){
                    // _params.startDate = this.$options.filters['zmdatetime'](this.queryform.date[0]);
                    // _params.endDate = this.$options.filters['zmdatetime'](this.queryform.date[1]);
                    _params.startDate = this.queryform.date[0];
                    _params.endDate = this.queryform.date[1];
                }
                _params.excelTemplateId = this.excelTemplateId;
                _params.importType = this.importType;
                return {
                    url:'cmn/excelimport/list',
                    params:_params
                }
            },
            downloadUploadFile(value,row){
                this.$tmsglobal.downloadImportExcel(row.batchNo,1);
            },
            downloadErrorFile(value,row){
                this.$tmsglobal.downloadImportExcel(row.batchNo,2);
            },
            query(){
                this.$refs['maintable'].query()
            },
            handleResult(res){
                for(let i=0; i<res.length; i++){
                    if(res[i].importStatus != "5" && res[i].importStatus != "6"){
                        res[i].modifyDatetime = "";
                    }else{
                        let differTime = this.calculateTime(res[i].createDatetime, res[i].modifyDatetime);
                        res[i].differTime = differTime;
                    }
                }
            },
            calculateTime(startTime, endTime){
                if(startTime==null || endTime==null || startTime>endTime){
                    return null;
                }else{
                    let differTime = "";
                    let leave1 = endTime - startTime; //相差毫秒
                    let hour = Math.floor(leave1 / (3600 * 1000)) //小时数
                    let leave2 = leave1 % (3600 * 1000) //计算小时后剩余毫秒数
                    let minute = Math.floor(leave2 / (60 * 1000)); //分钟数
                    let leave3 = leave2 % (60 * 1000); //计算分钟后剩余毫秒数
                    let second = Math.floor(leave3 / 1000); //秒数
                    let millisecond = leave3 % 1000; //剩余毫秒数
                    if(hour != null && hour != 0){
                        differTime +=  hour + "h"
                    }
                    if(minute != null && minute != 0){
                        differTime +=  minute + "m"
                    }
                    if(second != null && second != 0){
                        differTime += second + "s"
                    }
                    if(millisecond != null && millisecond != 0 ){
                        differTime += millisecond + "ms"
                    }
                    return differTime;
                }
            }
        },
        created(){
            var sysType = this.$util.get('sysType');
            if(sysType && 'tms' == sysType){
                this.statshow = true;
            }else{
                this.statshow = false;
            }
        }
    };
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// ../../src/components/ImportLog/index.vue